import { Box, Chip } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { FeatureInputSupplier } from '../../../../types/advise';
import { roundTripLine } from './SupplierFeatureInput.calc';

interface RoundTripCardProps {
  supplier: FeatureInputSupplier;
  canEdit: boolean;
  canExport: boolean;
  onExport: () => void;
  onImport: () => void;
}

export const RoundTripCard = ({ supplier, canEdit, canExport, onExport, onImport }: RoundTripCardProps) => (
  <Box className="flex flex-col gap-1 rounded-lg border border-grey-3 p-3">
    <Box className="flex items-center justify-between gap-2">
      <TextSpan weight="semibold">{supplier.supplier_name}</TextSpan>
      {supplier.imported_at && (
        <Chip
          label="Imported"
          color="success"
          size="small"
        />
      )}
    </Box>
    {!supplier.imported_at && (
      <TextSpan
        size="sm"
        color="grey6">
        No response imported yet
      </TextSpan>
    )}
    <TextSpan
      size="xs"
      color="grey6">
      {roundTripLine(supplier)}
    </TextSpan>
    {canEdit && (
      <Box className="mt-1 flex flex-col items-start gap-1">
        <TextButton
          disabled={!canExport}
          onClick={onExport}>
          Export requirement sheet →
        </TextButton>
        <TextButton onClick={onImport}>Review &amp; import response →</TextButton>
      </Box>
    )}
  </Box>
);
